import mixpanel, { Callback } from 'mixpanel-browser';
import { config } from 'src/config';
import getQueryParam from 'src/helpers/getQueryParam';
import getQueryParams from 'src/helpers/getQueryParams';
import isIpad from 'src/helpers/isIpad';

const MIXPANEL_MODULE_NAME = 'signup-webapp';

export const initializeMixpanel = () => {
  mixpanel.init(config.mixPanelProjectToken, {
    debug: config.env !== 'prd',
    track_pageview: false,
    persistence: 'localStorage',
    opt_out_tracking_by_default: true,
  });
};

export const enableMixpanel = () => {
  mixpanel.opt_in_tracking();

  const {
    country: countryCode,
    storeId,
    source,
  } = getQueryParams('country', 'storeId', 'source');
  const { tenant } = config;

  // Register mixpanel super properties
  mixpanel.register({
    moduleName: MIXPANEL_MODULE_NAME,
    tenant,
    countryCode,
    source,
    storeId,
    deviceType: isIpad() ? 'store-iPad' : 'personal',
  });
  identifyInMixpanel();
};

const identifyInMixpanel = () => {
  const storeId = getQueryParam('storeId');
  if (storeId) {
    mixpanel.identify(`signup-${storeId}`);
  }
};

type MixPanelEvent = {
  name: string;
  properties?: Record<string, string>;
};

export const trackEventMixpanel = (
  event: MixPanelEvent,
  callback?: Callback
): void => {
  mixpanel.track(event.name, event.properties, callback);
};
